import { GameObject } from './gameobject';

export class ProxyObject extends GameObject {
    constructor(world?: any) {
      // Proxy objects shouldn't need a world reference.
      super('proxy', null);
    }

}

/**
 * A class used as a placeholder for objects which are not actually visible
 * locally.  This allows us to share various tracking details between objects
 * which are tracking the same out-of-sight character.
 *
 * @constructor
 */


